import { API } from "@/services"

export const USERS_ENDPOINTS = {
  findMe(params={}){
    return API.Axios.callstats.v1.request({
      url: `users/me`,
      method: 'GET',
      params,
    })
  },
  updatePassword(data={}){
    return API.Axios.callstats.v1.request({
      url: `users/password`,
      method: 'PATCH',
      data,
    })
  },
}